// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { GrantedPermissions } from "../../models"
import { AccountDTO } from "./AccountDTO"
import { IAccount } from "./IAccount"
import { IAccountClient } from "./IAccountClient"


export class Account implements IAccount {
  private client: IAccountClient
  private data: AccountDTO

  constructor(client: IAccountClient, data: AccountDTO) {
    this.client = client
    this.data = data
    if (!data.annotations) {
      this.data.annotations = {}
    }
  }

  canUse(stage: string): boolean {
    return this.data.availability === stage
  }

  getDisplayName(): string {
    return this.data.organizationName
  }

  getIdentifier(): number | string {
    if (!this.data.id) {
      throw "Account does not have an identifier."
    }
    return this.data.id
  }

  isCreated(): boolean {
    return !!this.data.id
  }

  async getAllPermissions(): Promise<GrantedPermissions> {
    //@ts-ignore
    return (!!this.data.id)
      ? await this.client.getAllPermissions(this.data.id)
      : []
  }

  async persist(): Promise<void> {
    await this.client.persist(this.data, !this.isCreated())
  }
}